export * from './building.component';